






















import Vue from "vue";

interface Methods {
  onClickOutSide: () => void;
}

interface Props {
  title: string;
  content?: string;
  action?: string;
  close?: () => void;
}

export default Vue.extend<{}, Methods, {}, Props>({
  methods: {
    onClickOutSide() {
      const { close } = this;
      if (!close) {
        this.$close(false);
        return;
      }

      close();
    },
  },

  props: {
    title: {
      type: String,
      default: "",
    },
    close: Function,
    content: String,
    action: String,
  },
});

export type CupertinoAlertDialogProps = Props;
